import { render } from "./AccountInfo.vue?vue&type=template&id=c4cbab14&scoped=true&ts=true"
import script from "./AccountInfo.vue?vue&type=script&lang=ts"
export * from "./AccountInfo.vue?vue&type=script&lang=ts"

import "./AccountInfo.vue?vue&type=style&index=0&id=c4cbab14&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cbab14"]])

export default __exports__